export const LOADED_REPORT = "LOADED_REPORT";
export const TOGGLED_SME_MODE = "TOGGLED_SME_MODE";
export const UPDATED_ENGAGEMENT_ANSWER = "UPDATED_ENGAGEMENT_ANSWER";
export const UPDATED_ANALYTICS_ANSWER = "UPDATED_ANALYTICS_ANSWER";
export const RESET_ANALYTICS_STATE = "RESET_ANALYTICS_STATE";
export const GETTING_REPORT = "GETTING_REPORT";
export const GOT_FEDERAL_TAXES = "GOT_FEDERAL_TAXES";
